export default "__VITE_ASSET__5369348f__"